module.exports = __webpack_public_path__ + "c31144c52d3a2dcc3ce1f6e42259b1ff.pdf";